export const COUNSEL_SOURCE_MAP = {
    "CLINIC": {
        name: "의원",
    },
    "DOCTOR": {
        name: "의사",
    },
    "EVENT": {
        name: "이벤트",
    },
    "REVIEW": {
        name: "리뷰",
    },
}

export const COUNSEL_STATE_MAP = {
    // 🔹 상담(내원) 예약 관련 상태
    AWAITING_CLINIC_CONFIRMATION: {
        name: "병원 확인 대기",
    },
    CLINIC_CONFIRMED: {
        name: "병원 확인 완료",
    },
    CONSULTATION_APPOINTMENT_CONFIRMED: { // 내원 예약 확정
        name: "상담 예약 확정",
    },
    CONSULTATION_COMPLETE: {
        name: "상담 완료",
    },

    // 🔹 시술 예약 관련 상태
    TREATMENT_APPOINTMENT_CONFIRMED: { // 시술 예약 확정
        name: "시술 예약 확정",
    },
    TREATMENT_COMPLETE: {
        name: "시술 완료",
    },

    // 🔹 취소 상태
    CANCELED: {
        name: "취소됨",
    },
}